module.exports = __webpack_public_path__ + "img/gold8.17ff47d4.gif";